import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { useTranslate } from "../../hooks/useTranslate";
import { ICardManagementProps } from "../../modules/management/interfaces";

import { Wrapper, WrapperDate, Description, AboutManagement } from "./styles";

const CardManagement = ({
  title,
  farmer,
  date,
  total,
  url,
}: ICardManagementProps) => {
  const navigate = useNavigate();
  const { translate } = useTranslate();

  const day = date.getDate();
  const month = format(date, "MMM").toUpperCase();

  return (
    <Wrapper
      onClick={() => {
        navigate(url);
      }}
    >
      <WrapperDate>
        <span>{day}</span>
        <span>{month}</span>
      </WrapperDate>
      <Description>
        <AboutManagement>
          <p>{title}</p>
          <span>
            {translate("management.by")} {farmer}
          </span>
        </AboutManagement>
        <span>
          {total} {translate("management.animals")}
        </span>
      </Description>
    </Wrapper>
  );
};

export { CardManagement };
